/**
 * @generated SignedSource<<eaf146a29d51a14162a81d9ed5cd357c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MeetingHeader_meetingRecording$data = {
  readonly id: string;
  readonly title: string;
  readonly " $fragmentType": "MeetingHeader_meetingRecording";
};
export type MeetingHeader_meetingRecording$key = {
  readonly " $data"?: MeetingHeader_meetingRecording$data;
  readonly " $fragmentSpreads": FragmentRefs<"MeetingHeader_meetingRecording">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MeetingHeader_meetingRecording",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    }
  ],
  "type": "MeetingRecording",
  "abstractKey": null
};

(node as any).hash = "ecd15cb41cf3190d24770cf9a1a22df3";

export default node;
